(() => {
  if (window.ixLiveChatBound) return;
  window.ixLiveChatBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ix-live-chat]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const open = () => {
      const chat = window.RichpanelAppProxy;
      if (!chat || typeof chat.showMessenger !== 'function') return false;
      try {
        chat.showMessenger();
        return true;
      } catch (_) {
        return false;
      }
    };
    if (open()) return;
    link.setAttribute('aria-busy', 'true');
    const started = Date.now();
    const timer = window.setInterval(() => {
      if (open()) {
        window.clearInterval(timer);
        link.removeAttribute('aria-busy');
      } else if (Date.now() - started >= 10000) {
        window.clearInterval(timer);
        link.removeAttribute('aria-busy');
        if (!link.hasAttribute('data-ix-chat-no-fallback')) window.location.assign(link.href);
      }
    }, 250);
  });
})();